import { render, staticRenderFns } from "./LicensesChargedRenderer.vue?vue&type=template&id=6551e1d0"
import script from "./LicensesChargedRenderer.vue?vue&type=script&lang=js"
export * from "./LicensesChargedRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports